{
    "accept": "Acceptă",
    "all": "Toate",
    "apply": "Aplică",
    "back": "Înapoi",
    "cancel": "Anulare",
    "choose": "Alege",
    "clear": "Ștergere",
    "client_offline_error_description": "Ești offline. Te rugăm să verifici conexiunea la internet și să încerci din nou.",
    "client_offline_error_title": "Fără conexiune la internet",
    "client_timeout_error_description": "Nu am putut finaliza cererea ta din cauza expirării conexiunii. Te rugăm să verifici conexiunea și să încerci din nou. Dacă problema persistă, echipa noastră de asistență este aici să te ajute.",
    "client_timeout_error_title": "Conexiunea a expirat.",
    "delete": "Ștergere",
    "description": "Descriere",
    "dismiss": "Respinge",
    "done": "Gata",
    "error_occurred": "A avut loc o eroare",
    "expired": "Expirat",
    "field_address_search_accuracy_hint": "Îmbunătățește rezultatele căutării permițând aplicației accesul la locația ta din setările sistemului de operare.",
    "field_error_address_unsupported_country": "Adresa nu se află într-o țară acceptată",
    "field_error_any": "Completați vă rog cel puțin unul dintre aceste câmpuri: ${1}",
    "field_error_date_invalid": "Introduceți vă rog o dată validă",
    "field_error_date_max": "Data trebuie să fie ${1} sau înainte de această zi",
    "field_error_date_min": "Data trebuie să fie ${1} sau după această zi",
    "field_error_date_range_max": "Data trebuie să fie înainte de ${1}",
    "field_error_date_range_min": "Data trebuie să fie după ${1}",
    "field_error_email": "Introduceți vă rog o adresă de e-mail validă",
    "field_error_length_max": "Câmpul poate conține maximum ${1} caractere",
    "field_error_length_min": "Introduceți vă rog cel puțin ${1} caractere",
    "field_error_max": "Valoarea maximă este ${1}",
    "field_error_min": "Valoarea minimă este ${1}",
    "field_error_pattern": "Datele introduse sunt invalide",
    "field_error_phone_invalid": "Introduceți vă rog un număr de telefon valid",
    "field_error_phone_starts_with_zero": "Există deja un cod de țară. Vă rugăm să eliminați \"0\" din numărul de telefon.",
    "field_error_required": "Completați vă rog acest câmp",
    "field_is_required": "Acest câmp este obligatoriu",
    "field_placeholder_address_search": "Introduceți locația",
    "field_select_not_found": "${1} nu a putut fi găsit",
    "link_sent": "Link trimis, te rugăm să verifici",
    "network_error": "Eroare de rețea",
    "network_error_cookies_disabled_description": "Se pare că ai dezactivat toate cookie-urile. Poate încearcă un alt browser",
    "network_error_cookies_disabled_title": "Cookie-uri dezactivate",
    "next": "Înainte",
    "no_results": "Nu sunt rezultate",
    "offline": "offline",
    "ok": "OK",
    "online": "online",
    "open": "Deschidere",
    "page_not_found_description": "Pagina pe care ați încercat să o solicitați nu există. Este posibil să fi tastat greșit adresa URL.",
    "page_not_found_link": "Reveniți la pagina principală.",
    "page_not_found_title": "Pagina nu a fost găsită",
    "request_support": "Solicită asistență",
    "request_support_error_title": "Cererea a eșuat",
    "request_support_success_description": "Am primit cererea ta de asistență.",
    "request_support_success_title": "Cerere primită",
    "result": "Rezultat",
    "retry": "Reîncearcă",
    "save": "Salvați",
    "select_group_selected": "Selectat",
    "send_a_support_request": "Cerere de asistență",
    "server_unavailable_error_description": "Serviciul este temporar indisponibil. Te rugăm să verifici din nou mai târziu.",
    "server_unavailable_error_title": "Serviciu indisponibil",
    "server_unexpected_error_description": "Ceva nu a funcționat corect de partea noastră. Te rugăm să încerci din nou peste câteva momente. Dacă problema persistă, te rugăm să contactezi echipa noastră de asistență.",
    "server_unexpected_error_title": "A apărut o eroare neașteptată.",
    "state_done": "Gata",
    "state_not_uploaded": "Neîncărcat",
    "state_pending": "În așteptare",
    "state_refused": "Refuzat",
    "state_uploading": "Se încarcă",
    "submit": "Trimitere",
    "support_request_type": "Tip",
    "support_request_type_crash": "Blocare",
    "support_request_type_critical": "Critic",
    "support_request_type_minor": "Minor",
    "support_request_type_other": "Altele",
    "type": "Tip",
    "unknown_error": "Ceva nu a mers bine",
    "unknown_error_description": "A apărut o eroare neașteptată. Te rugăm să încerci din nou. Dacă problema persistă, contactează echipa de asistență.",
    "uploading": "Se încarcă...",
    "validating": "Stai puțin, ne asigurăm că totul este corect..."
}